import React, { forwardRef } from 'react';

import { useTheme } from '@mui/material';
import type { AlineButtonProps } from 'src/components';
import { AlineButton } from 'src/components';

export const SmallAlineButton = forwardRef(function SmallRectAlineButton(
  props: Omit<AlineButtonProps, 'size'>,
  ref: React.Ref<HTMLButtonElement>
) {
  const { children, ...rest } = props;
  const theme = useTheme();

  return (
    <AlineButton
      ref={ref}
      size="small"
      style={{
        borderRadius: 16,
        boxSizing: 'border-box',
        height: 24,
        padding: theme.spacing(0.5, 1),
      }}
      {...rest}
    >
      {children}
    </AlineButton>
  );
});
